import { defineStore } from 'pinia';
import { authService } from '../services/auth-service';
import { useOtpStore } from '@/modules/otp/stores/use-otp-store';

export const useLoginStore = defineStore('login-store', {
    state: () => ({
        step: 'credentials',

        identifier:      '',
        password:        '',
        newPassword:     '',
        confirmPassword: '',

        pendingUser:        null,
        mustChangePassword: false,

        processing:       false,
        error:            '',
        validationErrors: null,
    }),

    actions: {
        async submitCredentials() {
            this.error            = '';
            this.validationErrors = null;
            this.processing       = true;
            try {
                const { data } = await authService.login(this.identifier, this.password);
                this.pendingUser        = data.user;
                this.mustChangePassword = !!data.must_change_password;

                if (data.next === 'code') {
                    const otpStore = useOtpStore();
                    const channel  = this.identifier.includes('@') ? 'email' : 'sms';
                    await otpStore.send(this.identifier, channel);
                    this.step = 'otp';
                    return null;
                }

                if (this.mustChangePassword) {
                    this.step = 'set-password';
                    return null;
                }

                return { done: true, user: data.user };
            } catch (e) {
                if (e.response?.status === 422) {
                    const errors = e.response.data?.errors || null;
                    if (errors?.credentials) {
                        this.error = 'The provided credentials are incorrect.';
                    } else {
                        this.validationErrors = errors;
                    }
                } else {
                    this.error = e.response?.data?.message || 'Something went wrong. Please try again.';
                }
                return null;
            } finally {
                this.processing = false;
            }
        },

        async submitNewPassword() {
            this.error            = '';
            this.validationErrors = null;
            this.processing       = true;
            try {
                await authService.setPassword(this.newPassword, this.confirmPassword);
                return { done: true, user: this.pendingUser };
            } catch (e) {
                if (e.response?.status === 422) {
                    const errors = e.response.data?.errors || null;
                    if (errors?.password || errors?.password_confirmation) {
                        this.validationErrors = errors;
                    } else {
                        this.error = e.response.data?.message || 'Could not set password. Try again.';
                    }
                } else {
                    this.error = e.response?.data?.message || 'Could not set password. Try again.';
                }
                return null;
            } finally {
                this.processing = false;
            }
        },

        backToCredentials() {
            this.step             = 'credentials';
            this.identifier       = '';
            this.password         = '';
            this.error            = '';
            this.validationErrors = null;
            this.pendingUser      = null;
            useOtpStore().reset();
        },

        reset() {
            useOtpStore().reset();
            this.$reset();
        },
    },
});
